// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1AGU1","title":"AfterFrontImage_title__2ghXs"};